module.exports = __webpack_public_path__ + "f162bccc909f1cdf3b94c0f355cb8fb8.png";